module.exports = __webpack_public_path__ + "static/logo_text_light.a489b08b.png";